<script setup>
import Carousel from 'primevue/carousel';

import ad1 from "@/assets/imgs/welcome/step01-3.png"
import ad2 from "@/assets/imgs/welcome/step03-1.png"

import { useStoreSite } from '@/stores/store.site';

const storeSite = useStoreSite()

const adCopy1 = "Click 'Global Payments' and harness the power of MEYZERPay for secure and competitive rates. Simplify your payment journey and unlock a world of convenience with our trusted platform.";
const adCopy2 = "Click 'Apply Now' to embark on a seamless journey through our global payments application. Join MEYZERPay for a smarter, faster, and more efficient way to handle your global transactions.";

const ads = [{ img: ad1, copy:adCopy1 }, { img: ad2, copy:adCopy2 }]
</script>

<template>

<Carousel :value="ads" :numVisible="1">
    <template #item="{data}">
			<div class="surface-100 border-1 surface-border border-round mt-3 p-3 ">
				<Image :src="data.img" imageClass="w-full" :preview="storeSite.isMobile" />
			</div>
			<div class="text-left mt-4">{{data.copy}}</div>
    </template>
</Carousel>


</template>

<style scoped lang="scss">
.carousel__item {
	width:100%;
}

.carousel__slide {
	padding: 8px;
}
</style>
